import $ from 'jquery';

$(function () {
    const $app = $('#inf-app');
    if (!$app.length) return;

    const unitPerAnnum = $app.data('unit-per-annum') || '% річних';
    const unitMonth = $app.data('unit-month') || 'міс';
    const gainOverText = $app.data('inf-gain-over') || 'понад інфляцію';
    const gainLagText = $app.data('inf-gain-lag') || 'відставання';
    const textMoreCurrencies = $app.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $app.data('text-more-short') || 'Ще';

    // Currency configurations
    const currencyConfigs = {
        UAH: {
            symbol: '₴',
            defaultBudget: 40000,
            minBudget: 5000,
            maxBudget: 250000,
            stepBudget: 2500,
            baseCash: 100000,
            officialCpi: 11.2,
            shieldYield: (0.40 * 15.0) + (0.30 * 10.0) + (0.30 * 13.0),
            rates: { food: 14.5, rent: 18.5, transport: 12.0, health: 13.5, clothing: 4.5, cafes: 15.0, services: 8.0 }
        },
        USD: {
            symbol: '$',
            defaultBudget: 3500,
            minBudget: 500,
            maxBudget: 25000,
            stepBudget: 250,
            baseCash: 10000,
            officialCpi: 2.8,
            shieldYield: (0.40 * 4.5) + (0.30 * 10.0) + (0.30 * 3.5),
            rates: { food: 3.2, rent: 4.5, transport: 2.5, health: 3.8, clothing: 1.5, cafes: 3.5, services: 3.0 }
        },
        EUR: {
            symbol: '€',
            defaultBudget: 2800,
            minBudget: 400,
            maxBudget: 20000,
            stepBudget: 200,
            baseCash: 8000,
            officialCpi: 2.4,
            shieldYield: (0.40 * 3.2) + (0.30 * 8.5) + (0.30 * 2.5),
            rates: { food: 2.8, rent: 4.0, transport: 2.2, health: 3.2, clothing: 1.2, cafes: 3.0, services: 2.8 }
        },
        PLN: {
            symbol: 'zł',
            defaultBudget: 6500,
            minBudget: 1000,
            maxBudget: 40000,
            stepBudget: 500,
            baseCash: 20000,
            officialCpi: 4.5,
            shieldYield: (0.40 * 6.2) + (0.30 * 10.0) + (0.30 * 5.0),
            rates: { food: 5.2, rent: 6.8, transport: 4.0, health: 5.0, clothing: 2.5, cafes: 5.5, services: 4.5 }
        },
        GBP: {
            symbol: '£',
            defaultBudget: 2600,
            minBudget: 400,
            maxBudget: 20000,
            stepBudget: 200,
            baseCash: 8000,
            officialCpi: 2.6,
            shieldYield: (0.40 * 4.2) + (0.30 * 8.5) + (0.30 * 4.0),
            rates: { food: 3.0, rent: 4.2, transport: 2.6, health: 3.4, clothing: 1.4, cafes: 3.2, services: 3.0 }
        },
        CHF: {
            symbol: 'Fr.',
            defaultBudget: 5500,
            minBudget: 1000,
            maxBudget: 35000,
            stepBudget: 500,
            baseCash: 15000,
            officialCpi: 1.2,
            shieldYield: (0.40 * 1.2) + (0.30 * 6.5) + (0.30 * 1.0),
            rates: { food: 1.5, rent: 2.2, transport: 1.2, health: 1.8, clothing: 0.8, cafes: 1.6, services: 1.4 }
        },
        CAD: {
            symbol: 'C$',
            defaultBudget: 4200,
            minBudget: 600,
            maxBudget: 30000,
            stepBudget: 300,
            baseCash: 12000,
            officialCpi: 2.5,
            shieldYield: (0.40 * 3.8) + (0.30 * 9.0) + (0.30 * 3.2),
            rates: { food: 3.0, rent: 4.2, transport: 2.4, health: 3.2, clothing: 1.4, cafes: 3.4, services: 2.8 }
        },
        CZK: {
            symbol: 'Kč',
            defaultBudget: 45000,
            minBudget: 8000,
            maxBudget: 250000,
            stepBudget: 2500,
            baseCash: 120000,
            officialCpi: 2.8,
            shieldYield: (0.40 * 4.2) + (0.30 * 10.0) + (0.30 * 3.8),
            rates: { food: 3.5, rent: 4.8, transport: 2.8, health: 3.6, clothing: 1.8, cafes: 3.8, services: 3.2 }
        }
    };

    let activeCurrency = $app.data('currency') || 'UAH';
    if (!currencyConfigs[activeCurrency]) {
        activeCurrency = 'UAH';
    }

    // State
    const state = {
        monthlyBudget: currencyConfigs[activeCurrency].defaultBudget,
        weights: {
            food: 35,
            rent: 25,
            transport: 15,
            health: 5,
            clothing: 5,
            cafes: 10,
            services: 5
        }
    };

    // Presets
    const presets = {
        family: {
            food: 40,
            rent: 20,
            transport: 10,
            health: 10,
            clothing: 5,
            cafes: 5,
            services: 10
        },
        renter: {
            food: 25,
            rent: 45,
            transport: 10,
            health: 5,
            clothing: 5,
            cafes: 5,
            services: 5
        },
        driver: {
            food: 30,
            rent: 15,
            transport: 30,
            health: 5,
            clothing: 5,
            cafes: 10,
            services: 5
        },
        freelance: {
            food: 30,
            rent: 25,
            transport: 5,
            health: 5,
            clothing: 5,
            cafes: 20,
            services: 10
        }
    };

    function formatMoney(num) {
        if (isNaN(num) || !isFinite(num)) num = 0;
        const cfg = currencyConfigs[activeCurrency];
        return `${Math.round(num).toLocaleString()} ${cfg.symbol}`;
    }

    function calculate() {
        const cfg = currencyConfigs[activeCurrency];
        const totalWeight = Object.values(state.weights).reduce((a, b) => a + b, 0);
        let myInflationRate = 0;

        if (totalWeight > 0) {
            for (const [cat, weight] of Object.entries(state.weights)) {
                const normWeight = weight / totalWeight;
                const catRate = cfg.rates[cat] || cfg.officialCpi;
                myInflationRate += normWeight * catRate;
            }
        } else {
            myInflationRate = cfg.officialCpi;
        }

        const spread = myInflationRate - cfg.officialCpi;
        const annualLoss = state.monthlyBudget * (myInflationRate / 100);
        const monthlyLoss = annualLoss / 12;

        // Cash Erosion of baseCash
        const baseCash = cfg.baseCash;
        const r = myInflationRate / 100;
        const value1y = baseCash / (1 + r);
        const value3y = baseCash / Math.pow(1 + r, 3);
        const value5y = baseCash / Math.pow(1 + r, 5);

        const shieldYield = cfg.shieldYield;
        const realGain = shieldYield - myInflationRate;

        return {
            totalWeight,
            myInflationRate,
            spread,
            monthlyLoss,
            annualLoss,
            value1y,
            value3y,
            value5y,
            shieldYield,
            realGain
        };
    }

    function render() {
        const cfg = currencyConfigs[activeCurrency];
        const res = calculate();

        // Update KPIs
        $('#inf-kpi-rate').text(`${res.myInflationRate.toFixed(1)}%`);
        $('#inf-kpi-official').text(`${cfg.officialCpi.toFixed(1)}%`);

        const spreadSign = res.spread >= 0 ? '+' : '';
        const $diffVal = $('#inf-kpi-diff');
        $diffVal.text(`${spreadSign}${res.spread.toFixed(1)}%`);
        if (res.spread > 0) {
            $diffVal.removeClass('text-success').addClass('text-danger');
        } else {
            $diffVal.removeClass('text-danger').addClass('text-success');
        }

        $('#inf-kpi-loss').text(formatMoney(res.monthlyLoss));

        // Erosion Box
        $('#inf-pillow-1y').text(formatMoney(res.value1y));
        $('#inf-pillow-3y').text(formatMoney(res.value3y));
        $('#inf-pillow-5y').text(formatMoney(res.value5y));

        // Shield Box
        $('#inf-shield-yield').text(`${res.shieldYield.toFixed(1)}${unitPerAnnum}`);
        const $gainVal = $('#inf-shield-gain');
        if (res.realGain >= 0) {
            $gainVal.removeClass('text-danger').addClass('text-success').text(`+${res.realGain.toFixed(1)}% ${gainOverText}`);
        } else {
            $gainVal.removeClass('text-success').addClass('text-warning').text(`${res.realGain.toFixed(1)}% ${gainLagText}`);
        }

        // Sliders & Weight Labels
        for (const [cat, val] of Object.entries(state.weights)) {
            $(`#inf-range-${cat}`).val(val);
            $(`#inf-val-${cat}`).text(`${val}%`);
            const catAmt = formatMoney(state.monthlyBudget * (val / (res.totalWeight || 100)));
            $(`#inf-money-${cat}`).text(catAmt);
        }

        // Total percentage badge
        $('#inf-total-weight').text(`${res.totalWeight}%`);
        if (res.totalWeight === 100) {
            $('#inf-total-weight').removeClass('bg-warning bg-danger').addClass('bg-success text-white');
        } else {
            $('#inf-total-weight').removeClass('bg-success text-white').addClass('bg-warning text-dark');
        }

        $('#inf-budget-input').val(state.monthlyBudget);
        $('#inf-budget-range').val(state.monthlyBudget);
    }

    function updateCurrencyUI() {
        const cfg = currencyConfigs[activeCurrency];
        state.monthlyBudget = cfg.defaultBudget;
        $('#inf-budget-range')
            .attr('min', cfg.minBudget)
            .attr('max', cfg.maxBudget)
            .attr('step', cfg.stepBudget)
            .val(state.monthlyBudget);

        $('#inf-budget-input')
            .attr('min', cfg.minBudget / 2)
            .attr('max', cfg.maxBudget * 2)
            .attr('step', cfg.stepBudget)
            .val(state.monthlyBudget);

        $('#inf-budget-unit').text(`${cfg.symbol} / ${unitMonth}`);
        render();
    }

    // Event Listeners
    // Budget Sync
    $('#inf-budget-input').on('input change', function () {
        state.monthlyBudget = parseFloat($(this).val()) || 0;
        $('#inf-budget-range').val(state.monthlyBudget);
        render();
    });

    $('#inf-budget-range').on('input', function () {
        state.monthlyBudget = parseFloat($(this).val()) || 0;
        $('#inf-budget-input').val(state.monthlyBudget);
        render();
    });

    // Category Slider inputs
    $('input[data-inf-cat]').on('input', function () {
        const cat = $(this).data('inf-cat');
        const val = parseInt($(this).val(), 10) || 0;
        state.weights[cat] = val;
        render();
    });

    // Presets
    $('button[data-inf-preset]').on('click', function () {
        const pKey = $(this).data('inf-preset');
        const p = presets[pKey];
        if (!p) return;

        $('button[data-inf-preset]').removeClass('active btn-primary').addClass('btn-light');
        $(`button[data-inf-preset="${pKey}"]`).addClass('active btn-primary').removeClass('btn-light');

        state.weights = { ...p };
        render();
    });

    // Currency selection (Direct tabs)
    $(document).on('click', '#inf-currency-tabs > button[data-currency]', function () {
        $('#inf-currency-tabs button').removeClass('active');
        $(this).addClass('active');
        $('.inf-more-currencies-btn').removeClass('active');
        $('.inf-currency-dropdown-item').removeClass('active');
        $('#inf-active-custom-currency').html(`
            <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
            <span class="d-sm-none">${textMoreShort}</span>
        `);

        activeCurrency = $(this).data('currency');
        updateCurrencyUI();
    });

    // Currency selection (Dropdown items)
    $(document).on('click', '.inf-currency-dropdown-item', function (e) {
        e.preventDefault();
        const selCurr = $(this).data('currency');
        const selSymbol = $(this).data('symbol') || '$';

        $('#inf-currency-tabs > button[data-currency]').removeClass('active');
        $('.inf-currency-dropdown-item').removeClass('active');
        $(this).addClass('active');

        $('.inf-more-currencies-btn').addClass('active');
        $('#inf-active-custom-currency').text(`${selSymbol} ${selCurr}`);

        activeCurrency = selCurr;
        updateCurrencyUI();
    });

    // Initial render
    updateCurrencyUI();
});

